import {Layout} from "../../../src/ts/layouts/Layout";
import ScrollEvent = JQuery.ScrollEvent;

export class VideoBig extends Layout {

    private readonly SELECTOR_IFRAME: string = "iframe";


    private $iframe: JQuery;

    private scrollListener: EventListener;

    constructor($elem: JQuery) {
        super($elem);
        this.$iframe = this.$layout.find(this.SELECTOR_IFRAME);
        this.scrollListener = () => this.onWindowScroll();
        window.addEventListener('scroll', this.scrollListener);


    }

    private onWindowScroll() {
        if (this.isPartlyInViewport()) {
            console.log('invieport');
            const videoUrl = this.$iframe.data('video-url');
            this.$iframe.attr('src', videoUrl);
            window.removeEventListener('scroll', this.scrollListener);
        }
    }

    private isInViewport() {
        let bounding = this.$iframe[0].getBoundingClientRect();
        return (
            bounding.top >= 0 &&
            bounding.left >= 0 &&
            bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }

    private isPartlyInViewport() {
        let bounding = this.$iframe[0].getBoundingClientRect();

        return (
            (bounding.top > 0 &&
                bounding.top < (window.innerHeight || document.documentElement.clientHeight)) ||
            (bounding.bottom > 0 &&
                bounding.bottom < (window.innerHeight || document.documentElement.clientHeight))
        );
    }

}

